import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import {
  IconModule,
  IconRegistry,
  QuestionMarkCircleIcon,
} from '@ciam/library';
import { ProfileEditComponent } from './profile-edit.component';
import { VerifyPinComponent } from './verify-pin/verify-pin.component';
import { SharedModule } from 'src/app/shared/shared.module';

@NgModule({
  declarations: [
    ProfileEditComponent,
    VerifyPinComponent
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    TranslateModule,
    IconModule,
    SharedModule
  ],
  exports: [ProfileEditComponent]
})
export class ProfileEditModule {
  constructor(private iconRegistry: IconRegistry) {
    this.iconRegistry.register(
      QuestionMarkCircleIcon
    );
  }
}